export enum DevicesActionTypes {
  LOAD_DEVICES_REQUEST = 'LOAD_DEVICES_REQUEST',
  LOAD_DEVICES_SUCCEEDED = 'LOAD_DEVICES_SUCCEEDED',
  LOAD_DEVICES_FAILED = 'LOAD_DEVICES_FAILED',
  LOAD_DEVICE_STATUS_SUCCESS = 'LOAD_DEVICE_STATUS_SUCCESS',
}
